import { RefreshCw, Wallet } from "lucide-react";

import { InputDecimal } from "@/components/ui/input-decimal";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

import { comImposto as somarImposto, reais } from "../api";
import Cartao from "./Cartao";

const VALORES = [50, 100, 150, 200, 300];
const SEMANAS = [1, 2, 4, 8, 12];

/** Passo 4: quanto investir por semana e por quanto tempo (ou contínua, que renova sozinha). */
export default function SecaoQuanto({ a }) {
  const { form, definir, minimo, semanalCentavos } = a;
  const imposto = a.dados.imposto_pct || 0;
  const comImposto = somarImposto(semanalCentavos, imposto);
  const abaixo = minimo > 0 && semanalCentavos > 0 && semanalCentavos < minimo;
  const pouco = !abaixo && semanalCentavos > 0 && semanalCentavos < 10000;

  return (
    <Cartao numero={4} titulo="Quanto e por quanto tempo" icone={Wallet} e2e="impulsionar-quanto"
      descricao="Você decide o valor por semana. A Meta distribui pelos dias: num dia forte ela gasta mais, e a conta fecha na semana.">
      <div className="space-y-4">
        <div>
          <Label>Investimento por semana *</Label>
          <div className="mt-1 flex flex-wrap items-center gap-2">
            <span className="text-muted-foreground text-sm">R$</span>
            <div className="w-36"><InputDecimal decimals={2} value={form.semanal} onChange={(v) => definir("semanal", v)} data-e2e="impulsionar-campo-semanal" /></div>
            {VALORES.filter((v) => v * 100 >= minimo).map((v) => (
              <button key={v} type="button" onClick={() => definir("semanal", String(v))}
                className={`rounded-lg border px-2.5 py-1.5 text-xs font-medium tabular-nums ${semanalCentavos === v * 100 ? "border-primary bg-primary/10 text-primary" : "hover:border-primary"}`}>
                R$ {v}
              </button>
            ))}
          </div>
          <p className="text-[11px] text-muted-foreground mt-1.5" data-e2e="impulsionar-com-imposto">
            Com o imposto que a Meta repassa ({imposto.toLocaleString("pt-BR")}%), sai <b className="text-foreground">{reais(comImposto)} por semana</b> na sua conta de anúncios.
          </p>
          {abaixo && <p className="text-xs text-red-500 mt-1" data-e2e="impulsionar-abaixo-minimo">A Meta exige pelo menos {reais(minimo)} por semana nesta conta.</p>}
          {pouco && <p className="text-xs text-amber-600 mt-1">Abaixo de R$ 100 por semana o anúncio costuma demorar para a Meta aprender quem compra.</p>}
        </div>

        <div>
          <Label>Duração</Label>
          <div className="mt-1 flex flex-wrap gap-2">
            {SEMANAS.map((s) => (
              <button key={s} type="button" onClick={() => { definir("semanas", s); definir("continua", false); }} data-e2e={`impulsionar-semanas-${s}`}
                className={`rounded-lg border px-3 py-1.5 text-sm font-medium ${!form.continua && form.semanas === s ? "border-primary bg-primary/10 text-primary" : "hover:border-primary"}`}>
                {s} {s === 1 ? "semana" : "semanas"}
              </button>
            ))}
          </div>
        </div>

        <label className={`flex items-start justify-between gap-3 p-3 rounded-lg cursor-pointer ${form.continua ? "bg-amber-500/10 border border-amber-500/40" : "bg-muted"}`}>
          <span className="text-sm">
            <span className="flex items-center gap-2 font-medium"><RefreshCw className="w-4 h-4" /> Campanha contínua</span>
            <span className="block text-xs text-muted-foreground mt-0.5">
              {form.continua
                ? <>Renova sozinha toda semana (<b className="text-foreground">{reais(comImposto)}</b> com imposto) até você pausar ou encerrar. Avisamos no sino a cada renovação.</>
                : "Sem data para acabar: renova toda semana até você pausar ou encerrar."}
            </span>
          </span>
          <Switch checked={form.continua} onCheckedChange={(v) => definir("continua", v)} data-e2e="impulsionar-continua" />
        </label>
      </div>
    </Cartao>
  );
}
